import React from "react";
import { connect } from "react-redux";
import { change12LeadGraphSettings, fetchUpdate_RR_HR_QTc, prepareDataForSave } from "../../../redux/actions/report-actions";
import compose from "../../../utils/compose";

import getSubfragm from "../../../graphics/get-subfragm";
import withSignalGetter from "../../../hoc/with-signal-getter";
import withReportDataService from "../../../hoc/with-dataservice-consumer";

import { Spinner } from "../../state-indicators";
import { calcRRMarks } from "../../../graphics/graph-funcs";
import ECGGraphSVG, { lead12GraphSettings } from "../../../graphics/svg/ecg-graph-svg";
import { MagnifierX, MagnifierY } from "../../magnifier";
import getDiffProperties from "../../../utils/getDiffProperties";
import { parseSignal_LeadsInSeparateArrays } from "../../../graphics/graph-funcs";
import "./graph-12leads.scss";
import { bindActionCreators } from "redux";
import Slider from "../../ui/SliderComponent/SliderComponent";
import calcGraphSliderRange from "./calcGraphSliderRange";

class Graph12Leads extends React.Component {
    _mounted = false;
    _drawing = false;
    _needDraw = false;
    state = {
        loading: true,
        error: false,

        zoomXInDisabled: false,
        zoomXOutDisabled: false,
        zoomYInDisabled: false,
        zoomYOutDisabled: false,

        graphStart_initial: null,

        printSliderValue_initial: null,
        printSliderValue: null,
        printSliderRange: null
    };
    getReprCmpxArea(graphStart) {
        // Область обозначения на графике представительного комплекса
        let {
            Q,
            S,
            signal: { fd }
        } = this.props;

        Q = this.ms_pnt(Q);
        S = this.ms_pnt(S);

        const areaStart = Q - graphStart - 0.25 * fd,
            areaWidth = S + 2 * 0.25 * fd;
        return { areaStart, areaWidth };
    }
    preparePrintSlider(useUserGraphStartPoint = false) {
        let {
            scale: { timeScale_mm_s },
            signal: { signalLength }
        } = this.props;

        const { start: graphStart, length: graphLength } = this.getGraphInterval(timeScale_mm_s, useUserGraphStartPoint);
        const { areaStart, areaWidth } = this.getReprCmpxArea(graphStart);
        const { sliderValue, sliderRange } = calcGraphSliderRange(graphStart, graphLength, areaStart, areaWidth, signalLength);

        const data = {
            graphStart_initial: graphStart,
            sliderValue_initial: sliderValue,
            sliderValue,
            sliderRange
        };
        this.setState(data);
    }
    componentDidUpdate(prevProps) {
        const {
            scale: { timeScale_mm_s: timeScale_mm_s_p, voltageScale_mm_mV: voltageScale_mm_mV_p, start_pnt: start_pnt_p },
            signalFilters: filters_p,
            lang: lang_p,
            Q: Q_p
        } = prevProps;
        const {
            scale: { timeScale_mm_s, voltageScale_mm_mV, start_pnt },
            signalFilters: filters,
            lang,
            Q
        } = this.props;

        const changedStartPnt = start_pnt !== start_pnt_p;
        const changedXScaleOrQ = timeScale_mm_s_p !== timeScale_mm_s || Q !== Q_p;
        if (changedXScaleOrQ || changedStartPnt) {
            if (changedXScaleOrQ) {
                this.preparePrintSlider();
            }
            this.drawGraph();
        }
        if (voltageScale_mm_mV_p !== voltageScale_mm_mV || lang_p !== lang || JSON.stringify(filters) !== JSON.stringify(filters_p)) {
            this.drawGraph();
        }

        if (timeScale_mm_s_p !== timeScale_mm_s)
            this.setState({
                zoomXInDisabled: timeScale_mm_s >= this.xScales[this.xScales.length - 1],
                zoomXOutDisabled: timeScale_mm_s <= this.xScales[0]
            });

        if (voltageScale_mm_mV_p !== voltageScale_mm_mV)
            this.setState({
                zoomYInDisabled: voltageScale_mm_mV >= this.yScales[this.yScales.length - 1],
                zoomYOutDisabled: voltageScale_mm_mV <= this.yScales[0]
            });
    }
    ms_pnt = val => (val === undefined || val === null || val === "" ? null : Math.round((val * this.props.signal.fd) / 1000));
    drawGraph() {
        if (this._drawing) {
            this._needDraw = true;
            return;
        }

        // Data
        let {
            scale: { timeScale_mm_s },
            Q,
            S,
            reprCmpxIndex,
            signal: { fd, channelNames, reportFragmStart_pnt },
            complexes,
            prepared,
            stimulator,
            stimPositions
        } = this.props;
        if (Q === null || Q === undefined || !prepared) {
            this.drawSVG();
            this.setState({ error: false, loading: false });
            return;
        }
        Q = this.ms_pnt(Q);
        S = this.ms_pnt(S);
        // Fragment start length
        let { start, length } = this.getGraphInterval(timeScale_mm_s, true);

        // Cmpxs
        // Точки Q представляют не абсолютную координату, а внутри 36 секундного ЭКГ фрагмента, для заключения, поэтому +reportFragmStart_pnt
        const _shift = reportFragmStart_pnt - start;
        const cmpxs = complexes.Qs.map((v, i) => {
            return { Q: v + _shift, S: v + complexes.Ws[i] + _shift }; // - 1
        }).filter(cmpx => cmpx.Q >= 0 && cmpx.Q <= length);

        // If Q S positions of representative cmpx was changed, need to make a change in cmpx array
        let reprIndex = cmpxs.findIndex(c => c.Q === complexes.Qs[reprCmpxIndex] + _shift);
        if (reprIndex !== -1) {
            cmpxs[reprIndex].Q = Q + _shift;
            cmpxs[reprIndex].S = cmpxs[reprIndex].Q + S;
        }

        const { marks: marksRR } = calcRRMarks(
            cmpxs.map(cmpx => cmpx.Q),
            fd,
            5
        );

        const { areaStart, areaWidth } = this.getReprCmpxArea(start);

        // Get signal
        if (!this._mounted) {
            return;
        }

        this._drawing = true;
        let req = this.props.reqSignal(start, length);
        req.then(_data => {
            if (!this._mounted) {
                return;
            }
            let data = [];
            data = parseSignal_LeadsInSeparateArrays(_data.signal, 1000);

            const signal = {
                data_mV: data,
                fd,
                chQty: 12,
                ptsQty: data.length / 12,
                channelNames
            };

            const highlightAreas = {
                X_pnt: areaStart,
                Y_bottom_mm: 0,
                height_mm: 1,
                width_pts: areaWidth,
                color: "#888888"
            };
            let ticks = [{ X_pts: [...cmpxs.map(v => v.Q), ...cmpxs.map(v => v.S)] }];
            ticks = undefined; // Отключено

            const labels = {
                X_pts: marksRR.Xs_pnt,
                Y_mm: marksRR.Ys_mm,
                texts: marksRR.texts
            };

            let backgroundLines;

            // TODO Make UI settings to disable stim marks on graph
            const showStimOnGraph = false;

            if (showStimOnGraph && stimulator && stimPositions) {
                const stims = stimPositions.filter(st => st >= start && st < start + length);
                backgroundLines = {
                    X_pts: stims.map(x => x - start),
                    Y_mm: 0,
                    height_mm: lead12GraphSettings.graphSetts.height_mm - 1, // -1 тк в высоте полотна был заложен дополнительный мм
                    color: "#6d75768c", //"#0BB2BC",
                    width_mm: 0.75
                };
            }
            if (this.svgcontainer) {
                this.drawSVG({ signal, ticks, backgroundLines, labels, highlightAreas });
            }

            this._drawing = false;
            this.setState({ error: false, loading: false });
        })
            .catch(error => {
                if (!this._mounted) {
                    return;
                }

                if (this.svgcontainer) {
                    this.svgcontainer.innerText = "";
                    this.drawSVG();
                }

                this.setState({ error: true, loading: false });
                console.error(error);
            })
            .finally(() => {
                this._drawing = false;
                if (this._needDraw) {
                    this._needDraw = false;
                    this.drawGraph();
                }
            });
    }

    drawSVG = ({ signal, ticks, backgroundLines, labels, highlightAreas } = {}) => {
        const {
            loc,
            scale: { timeScale_mm_s, voltageScale_mm_mV }
        } = this.props;
        this.svgcontainer.innerText = "";
        const setts = lead12GraphSettings;
        setts.plotSetts.ScaleX_mm_sec = timeScale_mm_s;
        setts.plotSetts.ScaleY_mm_mV = voltageScale_mm_mV;
        const SvgECG = new ECGGraphSVG("ECG12LeadsGraph", setts);

        const svg = SvgECG.draw({ signal, ticks, backgroundLines, labels, highlightAreas, time_scale_str: loc("units.mm_sec") });
        this.svgcontainer.appendChild(svg);
    };

    componentDidMount() {
        this._mounted = true;
        const {
            scale: { timeScale_mm_s, voltageScale_mm_mV }
        } = this.props;
        const zoomDisabled = {
            zoomXInDisabled: timeScale_mm_s >= this.xScales[this.xScales.length - 1],
            zoomXOutDisabled: timeScale_mm_s <= this.xScales[0],
            zoomYInDisabled: voltageScale_mm_mV >= this.yScales[this.yScales.length - 1],
            zoomYOutDisabled: voltageScale_mm_mV <= this.yScales[0]
        };
        this.setState(zoomDisabled, () => this.preparePrintSlider(true));

        this.drawGraph();
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    prepareChangesForSaving = sett => {
        const {
            prepareDataForSave,
            scale: { timeScale_mm_s, voltageScale_mm_mV, start_pnt }
        } = this.props;
        let prepared = {};
        let { diff, same } = getDiffProperties(
            {
                graphReprCmpx_timeScale_mm_s: timeScale_mm_s,
                graphReprCmpx_voltageScale_mm_mV: voltageScale_mm_mV,
                graph12LeadStart_pnt: start_pnt
            },
            sett
        );
        diff.forEach(({ key, val }) => {
            if (val !== undefined) prepared[key] = val;
        });
        prepareDataForSave({ diff: prepared, same });
    };
    xScales = [10, 25, 50];
    yScales = [5, 10, 20, 40];

    getGraphInterval(scaleX, useUserGraphStartPoint = false) {
        // useUserGraphStartPoint - когда пользователь самостоятельно с помощью контрола указал начало графика
        const {
            Q: Q_ms,
            S: S_ms,
            signal: { signalLength, fd },
            scale: { start_pnt: user_start_pnt }
        } = this.props;
        const { ms_pnt } = this;
        const Q = ms_pnt(Q_ms);
        const S = ms_pnt(S_ms);
        // Fragment start length
        const length180mm = (180 / scaleX) * fd; // 180 mm
        let { start, length } = getSubfragm(signalLength, Math.round(Q + S / 2), length180mm);
        if (useUserGraphStartPoint && user_start_pnt !== undefined && user_start_pnt !== null) {
            start = user_start_pnt;
            length = Math.min(length, signalLength - user_start_pnt);
        }
        return { start, length };
    }
    timeoutID = undefined;
    onSliderChanged = sliderValue => {
        const { graphStart_initial, sliderValue_initial } = this.state;
        const delta = sliderValue - sliderValue_initial;
        const startExist = graphStart_initial !== undefined && graphStart_initial !== null;
        let user_start_pnt = startExist ? graphStart_initial + delta : null;

        const { changeSettings, updateRRHRQTc, reprCmpxIndex } = this.props;

        changeSettings({ start_pnt: user_start_pnt });
        this.prepareChangesForSaving({ graph12LeadStart_pnt: user_start_pnt });

        this.setState({ sliderValue });

        if (this.timeoutID) {
            clearTimeout(this.timeoutID);
        }
        this.timeoutID = setTimeout(() => {
            const {
                scale: { timeScale_mm_s }
            } = this.props;
            const { start, length } = this.getGraphInterval(timeScale_mm_s, true);
            updateRRHRQTc(start, start + length, reprCmpxIndex);
        }, 500);
    };

    xZoomIn = () => {
        const {
            changeSettings,
            updateRRHRQTc,
            scale: { timeScale_mm_s },
            reprCmpxIndex
        } = this.props;

        const newScale = this.xScales.find(_v => _v > timeScale_mm_s);
        if (newScale) {
            const { start, length } = this.getGraphInterval(newScale);
            changeSettings({ timeScale_mm_s: newScale, start_pnt: start });
            this.prepareChangesForSaving({ graph12Leads_timeScale_mm_s: newScale });
            updateRRHRQTc(start, start + length, reprCmpxIndex);
        }
    };
    xZoomOut = () => {
        const {
            changeSettings,
            updateRRHRQTc,
            scale: { timeScale_mm_s },
            reprCmpxIndex
        } = this.props;
        const newScale = this.xScales
            .slice()
            .reverse()
            .find(_v => _v < timeScale_mm_s);
        if (newScale) {
            const { start, length } = this.getGraphInterval(newScale);
            changeSettings({ timeScale_mm_s: newScale, start_pnt: start });
            this.prepareChangesForSaving({ graph12Leads_timeScale_mm_s: newScale });
            updateRRHRQTc(start, start + length, reprCmpxIndex);
        }
    };
    yZoomIn = () => {
        const {
            changeSettings,
            scale: { voltageScale_mm_mV }
        } = this.props;
        const newScale = this.yScales.find(_v => _v > voltageScale_mm_mV);

        if (newScale) {
            changeSettings({
                voltageScale_mm_mV: newScale
            });
            this.prepareChangesForSaving({
                graph12Leads_voltageScale_mm_mV: newScale
            });
        }
    };
    yZoomOut = () => {
        const {
            changeSettings,
            scale: { voltageScale_mm_mV }
        } = this.props;
        const newScale = this.yScales
            .slice()
            .reverse()
            .find(_v => _v < voltageScale_mm_mV);
        if (newScale) {
            changeSettings({
                voltageScale_mm_mV: newScale
            });
            this.prepareChangesForSaving({
                graph12Leads_voltageScale_mm_mV: newScale
            });
        }
    };

    render() {
        const { openDialog, popupable } = this.props;

        const { sliderValue, sliderRange } = this.state;

        const { loading, error, zoomXInDisabled, zoomXOutDisabled, zoomYInDisabled, zoomYOutDisabled } = this.state;
        const { xZoomIn, xZoomOut, yZoomIn, yZoomOut, onSliderChanged } = this;
        return (
            <div className={"report-graph report-graph-12leads-cmpx" + (error ? " error" : "") + (popupable ? " popup-able" : "")}>
                {popupable ? (
                    <button className="popup-open-btn" data-popup-window="wholeGraph-popup-window" onClick={openDialog}>
                        &#xE800;
                    </button>
                ) : null}
                <div
                    ref={_self => {
                        this.svgcontainer = _self;
                    }}
                    style={{ textAlign: "center" }}
                />
                <div className="slider-container">
                    <Slider {...{ onChange: onSliderChanged, value: sliderValue, max: sliderRange }} />
                </div>
                <MagnifierX zoomIn={xZoomIn} zoomOut={xZoomOut} disableOut={zoomXOutDisabled} disableIn={zoomXInDisabled} />
                <MagnifierY zoomIn={yZoomIn} zoomOut={yZoomOut} disableOut={zoomYOutDisabled} disableIn={zoomYInDisabled} />

                {loading ? <Spinner small transparent /> : null}
            </div>
        );
    }
}

const mapStateToProps = ({
    reportApp: {
        reportData: {
            report: { representativeCmpx, complexes, stimulator, stimPositions, signal },
            settings: {
                graphs: { graph12Leads: scale, signalFilters }
            }
        }
    }
}) => {
    let Q = null,
        S = null,
        reprCmpxIndex = null;
    if (representativeCmpx) ({ Q, S, index: reprCmpxIndex } = representativeCmpx);
    return {
        scale,
        Q: Q?.val,
        S: S?.val,
        complexes,
        signal,
        signalFilters,
        stimulator,
        stimPositions,
        reprCmpxIndex
    };
};
const mapDispatchToProps = (dispatch, { dataService: { req_RRHR_onInterval, previewDerivedParams } }) => {
    return bindActionCreators(
        {
            changeSettings: change12LeadGraphSettings,
            updateRRHRQTc: fetchUpdate_RR_HR_QTc(req_RRHR_onInterval),
            prepareDataForSave
        },
        dispatch
    );
};

export default compose(withSignalGetter, withReportDataService(), connect(mapStateToProps, mapDispatchToProps))(Graph12Leads);
